// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_org_fsd_flat.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  StcsFpnaTypeEnum,
  stcsFpnaTypeEnumFromJSON,
  stcsFpnaTypeEnumToJSON,
  StcsFstmtEnum,
  stcsFstmtEnumFromJSON,
  stcsFstmtEnumToJSON,
} from "./stcs_enums.entity";
import { StcsI18nLabelMap } from "./stcs_i18n.entity";
import { StcsOrgFsdStructOptions } from "./stcs_org_fsd_struct.entity";

export const protobufPackage = "stcs_cmw";

/** v1.1.0 */
export interface StcsOrgFsdFlat {
  id: string;
  version: string;
  meta: StcsOrgFsdFlatMeta | undefined;
  pnl_list: StcsOrgFsdFlatItem[];
  bs_list: StcsOrgFsdFlatItem[];
  cf_list: StcsOrgFsdFlatItem[];
  i18n_custom_key: string;
  i18n_map: { [key: string]: StcsI18nLabelMap };
  is_draft: boolean;
}

export interface StcsOrgFsdFlat_I18nMapEntry {
  key: string;
  value: StcsI18nLabelMap | undefined;
}

export interface StcsOrgFsdFlatMeta {
  display_name: string;
  version_name: string;
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
  ref_id_org: string;
  ref_id_user: string;
  ref_id_org_fsd_struct: string;
  is_custom: boolean;
  fpna_industry: number;
}

export interface StcsOrgFsdFlatItem {
  /** Financial statement type for this position -> P&L, BS, CF */
  fstmt_type: StcsFstmtEnum;
  /** FPNA position level type -> Total, Subtotal, Level 1, etc. */
  fpna_type: StcsFpnaTypeEnum;
  row_id: string;
  level_id: string;
  path_level: string[];
  rowClass: string;
  options: StcsOrgFsdStructOptions | undefined;
  sum_ref?: string | undefined;
  ref_id_prefix?: string | undefined;
  ref_id_mirror?: string | undefined;
}

function createBaseStcsOrgFsdFlat(): StcsOrgFsdFlat {
  return {
    id: "",
    version: "",
    meta: undefined,
    pnl_list: [],
    bs_list: [],
    cf_list: [],
    i18n_custom_key: "",
    i18n_map: {},
    is_draft: false,
  };
}

export const StcsOrgFsdFlat: MessageFns<StcsOrgFsdFlat> = {
  encode(message: StcsOrgFsdFlat, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsOrgFsdFlatMeta.encode(message.meta, writer.uint32(26).fork()).join();
    }
    for (const v of message.pnl_list) {
      StcsOrgFsdFlatItem.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.bs_list) {
      StcsOrgFsdFlatItem.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.cf_list) {
      StcsOrgFsdFlatItem.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.i18n_custom_key !== "") {
      writer.uint32(58).string(message.i18n_custom_key);
    }
    Object.entries(message.i18n_map).forEach(([key, value]) => {
      StcsOrgFsdFlat_I18nMapEntry.encode({ key: key as any, value }, writer.uint32(66).fork()).join();
    });
    if (message.is_draft !== false) {
      writer.uint32(72).bool(message.is_draft);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdFlat {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdFlat();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsOrgFsdFlatMeta.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pnl_list.push(StcsOrgFsdFlatItem.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.bs_list.push(StcsOrgFsdFlatItem.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.cf_list.push(StcsOrgFsdFlatItem.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.i18n_custom_key = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          const entry8 = StcsOrgFsdFlat_I18nMapEntry.decode(reader, reader.uint32());
          if (entry8.value !== undefined) {
            message.i18n_map[entry8.key] = entry8.value;
          }
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.is_draft = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdFlat {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsOrgFsdFlatMeta.fromJSON(object.meta) : undefined,
      pnl_list: globalThis.Array.isArray(object?.pnl_list)
        ? object.pnl_list.map((e: any) => StcsOrgFsdFlatItem.fromJSON(e))
        : [],
      bs_list: globalThis.Array.isArray(object?.bs_list)
        ? object.bs_list.map((e: any) => StcsOrgFsdFlatItem.fromJSON(e))
        : [],
      cf_list: globalThis.Array.isArray(object?.cf_list)
        ? object.cf_list.map((e: any) => StcsOrgFsdFlatItem.fromJSON(e))
        : [],
      i18n_custom_key: isSet(object.i18n_custom_key) ? globalThis.String(object.i18n_custom_key) : "",
      i18n_map: isObject(object.i18n_map)
        ? Object.entries(object.i18n_map).reduce<{ [key: string]: StcsI18nLabelMap }>((acc, [key, value]) => {
          acc[key] = StcsI18nLabelMap.fromJSON(value);
          return acc;
        }, {})
        : {},
      is_draft: isSet(object.is_draft) ? globalThis.Boolean(object.is_draft) : false,
    };
  },

  toJSON(message: StcsOrgFsdFlat): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsOrgFsdFlatMeta.toJSON(message.meta);
    }
    if (message.pnl_list?.length) {
      obj.pnl_list = message.pnl_list.map((e) => StcsOrgFsdFlatItem.toJSON(e));
    }
    if (message.bs_list?.length) {
      obj.bs_list = message.bs_list.map((e) => StcsOrgFsdFlatItem.toJSON(e));
    }
    if (message.cf_list?.length) {
      obj.cf_list = message.cf_list.map((e) => StcsOrgFsdFlatItem.toJSON(e));
    }
    if (message.i18n_custom_key !== "") {
      obj.i18n_custom_key = message.i18n_custom_key;
    }
    if (message.i18n_map) {
      const entries = Object.entries(message.i18n_map);
      if (entries.length > 0) {
        obj.i18n_map = {};
        entries.forEach(([k, v]) => {
          obj.i18n_map[k] = StcsI18nLabelMap.toJSON(v);
        });
      }
    }
    if (message.is_draft !== false) {
      obj.is_draft = message.is_draft;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdFlat>, I>>(base?: I): StcsOrgFsdFlat {
    return StcsOrgFsdFlat.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdFlat>, I>>(object: I): StcsOrgFsdFlat {
    const message = createBaseStcsOrgFsdFlat();
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsOrgFsdFlatMeta.fromPartial(object.meta)
      : undefined;
    message.pnl_list = object.pnl_list?.map((e) => StcsOrgFsdFlatItem.fromPartial(e)) || [];
    message.bs_list = object.bs_list?.map((e) => StcsOrgFsdFlatItem.fromPartial(e)) || [];
    message.cf_list = object.cf_list?.map((e) => StcsOrgFsdFlatItem.fromPartial(e)) || [];
    message.i18n_custom_key = object.i18n_custom_key ?? "";
    message.i18n_map = Object.entries(object.i18n_map ?? {}).reduce<{ [key: string]: StcsI18nLabelMap }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsI18nLabelMap.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.is_draft = object.is_draft ?? false;
    return message;
  },
};

function createBaseStcsOrgFsdFlat_I18nMapEntry(): StcsOrgFsdFlat_I18nMapEntry {
  return { key: "", value: undefined };
}

export const StcsOrgFsdFlat_I18nMapEntry: MessageFns<StcsOrgFsdFlat_I18nMapEntry> = {
  encode(message: StcsOrgFsdFlat_I18nMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsI18nLabelMap.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdFlat_I18nMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdFlat_I18nMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsI18nLabelMap.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdFlat_I18nMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsI18nLabelMap.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsOrgFsdFlat_I18nMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsI18nLabelMap.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdFlat_I18nMapEntry>, I>>(base?: I): StcsOrgFsdFlat_I18nMapEntry {
    return StcsOrgFsdFlat_I18nMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdFlat_I18nMapEntry>, I>>(object: I): StcsOrgFsdFlat_I18nMapEntry {
    const message = createBaseStcsOrgFsdFlat_I18nMapEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsI18nLabelMap.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsOrgFsdFlatMeta(): StcsOrgFsdFlatMeta {
  return {
    display_name: "",
    version_name: "",
    obj_created_iso_utc: "",
    obj_updated_iso_utc: "",
    ref_id_org: "",
    ref_id_user: "",
    ref_id_org_fsd_struct: "",
    is_custom: false,
    fpna_industry: 0,
  };
}

export const StcsOrgFsdFlatMeta: MessageFns<StcsOrgFsdFlatMeta> = {
  encode(message: StcsOrgFsdFlatMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.display_name !== "") {
      writer.uint32(18).string(message.display_name);
    }
    if (message.version_name !== "") {
      writer.uint32(26).string(message.version_name);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(34).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(42).string(message.obj_updated_iso_utc);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(50).string(message.ref_id_org);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(58).string(message.ref_id_user);
    }
    if (message.ref_id_org_fsd_struct !== "") {
      writer.uint32(66).string(message.ref_id_org_fsd_struct);
    }
    if (message.is_custom !== false) {
      writer.uint32(72).bool(message.is_custom);
    }
    if (message.fpna_industry !== 0) {
      writer.uint32(80).uint32(message.fpna_industry);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdFlatMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdFlatMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.version_name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.ref_id_org_fsd_struct = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.is_custom = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.fpna_industry = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdFlatMeta {
    return {
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : "",
      version_name: isSet(object.version_name) ? globalThis.String(object.version_name) : "",
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org_fsd_struct: isSet(object.ref_id_org_fsd_struct) ? globalThis.String(object.ref_id_org_fsd_struct) : "",
      is_custom: isSet(object.is_custom) ? globalThis.Boolean(object.is_custom) : false,
      fpna_industry: isSet(object.fpna_industry) ? globalThis.Number(object.fpna_industry) : 0,
    };
  },

  toJSON(message: StcsOrgFsdFlatMeta): unknown {
    const obj: any = {};
    if (message.display_name !== "") {
      obj.display_name = message.display_name;
    }
    if (message.version_name !== "") {
      obj.version_name = message.version_name;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org_fsd_struct !== "") {
      obj.ref_id_org_fsd_struct = message.ref_id_org_fsd_struct;
    }
    if (message.is_custom !== false) {
      obj.is_custom = message.is_custom;
    }
    if (message.fpna_industry !== 0) {
      obj.fpna_industry = Math.round(message.fpna_industry);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdFlatMeta>, I>>(base?: I): StcsOrgFsdFlatMeta {
    return StcsOrgFsdFlatMeta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdFlatMeta>, I>>(object: I): StcsOrgFsdFlatMeta {
    const message = createBaseStcsOrgFsdFlatMeta();
    message.display_name = object.display_name ?? "";
    message.version_name = object.version_name ?? "";
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org_fsd_struct = object.ref_id_org_fsd_struct ?? "";
    message.is_custom = object.is_custom ?? false;
    message.fpna_industry = object.fpna_industry ?? 0;
    return message;
  },
};

function createBaseStcsOrgFsdFlatItem(): StcsOrgFsdFlatItem {
  return {
    fstmt_type: 0,
    fpna_type: 0,
    row_id: "",
    level_id: "",
    path_level: [],
    rowClass: "",
    options: undefined,
    sum_ref: undefined,
    ref_id_prefix: undefined,
    ref_id_mirror: undefined,
  };
}

export const StcsOrgFsdFlatItem: MessageFns<StcsOrgFsdFlatItem> = {
  encode(message: StcsOrgFsdFlatItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fstmt_type !== 0) {
      writer.uint32(96).int32(message.fstmt_type);
    }
    if (message.fpna_type !== 0) {
      writer.uint32(8).int32(message.fpna_type);
    }
    if (message.row_id !== "") {
      writer.uint32(18).string(message.row_id);
    }
    if (message.level_id !== "") {
      writer.uint32(26).string(message.level_id);
    }
    for (const v of message.path_level) {
      writer.uint32(34).string(v!);
    }
    if (message.rowClass !== "") {
      writer.uint32(42).string(message.rowClass);
    }
    if (message.options !== undefined) {
      StcsOrgFsdStructOptions.encode(message.options, writer.uint32(66).fork()).join();
    }
    if (message.sum_ref !== undefined) {
      writer.uint32(74).string(message.sum_ref);
    }
    if (message.ref_id_prefix !== undefined) {
      writer.uint32(82).string(message.ref_id_prefix);
    }
    if (message.ref_id_mirror !== undefined) {
      writer.uint32(90).string(message.ref_id_mirror);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsOrgFsdFlatItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsOrgFsdFlatItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.fstmt_type = reader.int32() as any;
          continue;
        }
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.fpna_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.row_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.level_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.path_level.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.rowClass = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.options = StcsOrgFsdStructOptions.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.sum_ref = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.ref_id_prefix = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.ref_id_mirror = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsOrgFsdFlatItem {
    return {
      fstmt_type: isSet(object.fstmt_type) ? stcsFstmtEnumFromJSON(object.fstmt_type) : 0,
      fpna_type: isSet(object.fpna_type) ? stcsFpnaTypeEnumFromJSON(object.fpna_type) : 0,
      row_id: isSet(object.row_id) ? globalThis.String(object.row_id) : "",
      level_id: isSet(object.level_id) ? globalThis.String(object.level_id) : "",
      path_level: globalThis.Array.isArray(object?.path_level)
        ? object.path_level.map((e: any) => globalThis.String(e))
        : [],
      rowClass: isSet(object.rowClass) ? globalThis.String(object.rowClass) : "",
      options: isSet(object.options) ? StcsOrgFsdStructOptions.fromJSON(object.options) : undefined,
      sum_ref: isSet(object.sum_ref) ? globalThis.String(object.sum_ref) : undefined,
      ref_id_prefix: isSet(object.ref_id_prefix) ? globalThis.String(object.ref_id_prefix) : undefined,
      ref_id_mirror: isSet(object.ref_id_mirror) ? globalThis.String(object.ref_id_mirror) : undefined,
    };
  },

  toJSON(message: StcsOrgFsdFlatItem): unknown {
    const obj: any = {};
    if (message.fstmt_type !== 0) {
      obj.fstmt_type = stcsFstmtEnumToJSON(message.fstmt_type);
    }
    if (message.fpna_type !== 0) {
      obj.fpna_type = stcsFpnaTypeEnumToJSON(message.fpna_type);
    }
    if (message.row_id !== "") {
      obj.row_id = message.row_id;
    }
    if (message.level_id !== "") {
      obj.level_id = message.level_id;
    }
    if (message.path_level?.length) {
      obj.path_level = message.path_level;
    }
    if (message.rowClass !== "") {
      obj.rowClass = message.rowClass;
    }
    if (message.options !== undefined) {
      obj.options = StcsOrgFsdStructOptions.toJSON(message.options);
    }
    if (message.sum_ref !== undefined) {
      obj.sum_ref = message.sum_ref;
    }
    if (message.ref_id_prefix !== undefined) {
      obj.ref_id_prefix = message.ref_id_prefix;
    }
    if (message.ref_id_mirror !== undefined) {
      obj.ref_id_mirror = message.ref_id_mirror;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsOrgFsdFlatItem>, I>>(base?: I): StcsOrgFsdFlatItem {
    return StcsOrgFsdFlatItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsOrgFsdFlatItem>, I>>(object: I): StcsOrgFsdFlatItem {
    const message = createBaseStcsOrgFsdFlatItem();
    message.fstmt_type = object.fstmt_type ?? 0;
    message.fpna_type = object.fpna_type ?? 0;
    message.row_id = object.row_id ?? "";
    message.level_id = object.level_id ?? "";
    message.path_level = object.path_level?.map((e) => e) || [];
    message.rowClass = object.rowClass ?? "";
    message.options = (object.options !== undefined && object.options !== null)
      ? StcsOrgFsdStructOptions.fromPartial(object.options)
      : undefined;
    message.sum_ref = object.sum_ref ?? undefined;
    message.ref_id_prefix = object.ref_id_prefix ?? undefined;
    message.ref_id_mirror = object.ref_id_mirror ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
